import createDuck from '../lib/MetagnosticDuck'
import { getUsers, getUser } from '../lib/APIClient'

const emptyUser = {}

const duck = createDuck(
  "USERS", 
  getUser, 
  getUsers, 
  {}, 
  emptyUser, 
  null, 
  { idKey: "username" }
)


export const receiveUsers = duck.actions.receiveCollection
export const fetchUsers = duck.actions.fetchCollection

export default duck
